<template>
	<div>
		<a-modal :title="$t('recharge.recharge')" :width="650" :visible="visible" @cancel="handleCancel"
			:closable="false" :footer="null">
			<div class="cl-black ftr-1">
				{{ $t('recharge.rechargeAmount') }}
			</div>
			<!-- <a-input v-model:value="amountInfo.amount" type="number" :placeholder="$t('recharge.inputPrompt')"
				class="ft16 mt-3" @input="getAmount"  /> -->
			 <a-input-number id="inputNumber" v-model:value="amountInfo.amount" :min="1" :placeholder="$t('recharge.inputPrompt')" 
			  class="ft16 mt-3" @change="getAmount" style="width: 100%;" />
			<div class="border-gray br4 px-3 mt-3 ftr-1">
				<div class="flex justify-content-between border-b py-2">
					<div>
						{{ $t('recharge.thirdPartyFee') }}
					</div>
					<div>
						{{getCurrency()}}{{convertCurrency(amountInfo.amountCommission) }}
					</div>
				</div>
				<div class="flex justify-content-between py-2 ftw600 cl-black">
					<div>
						{{ $t('recharge.totalPrice') }}
					</div>
					<div>
						{{getCurrency()}}{{convertCurrency(amountInfo.total)}}
					</div>
				</div>
			</div>
			<div class="mt-4 d-flex justify-content-center">
				<button type="button" class="btn btn-outline-gray px-4" @click="handleCancel()">
					{{ $t('recharge.cancel') }} </button>
				<button type="button" class="btn btn-theme ml16 px-4" @click="moneyRecharge">
					{{ $t('recharge.submit') }} </button>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				amountInfo: {
					amount: undefined,
					amountCommission: 0,
					total: 0
				}
			}
		},
		methods: {
			handleCancel() {
				this.$emit('cancel')
			},
			getAmount() {
				this.amountInfo.amount = Number(this.amountInfo.amount)
				this.amountInfo.amountCommission = this.amountInfo.amount * 0.05
				this.amountInfo.total = this.amountInfo.amountCommission + this.amountInfo.amount
			},
			moneyRecharge() {
				if(this.amountInfo.amount==0||this.amountInfo.amount==''||this.amountInfo.amount==undefined){
					this.$message.error('請輸入儲值金額')
					return
				}
				this.$confirm({
					title: this.$t('recharge.confirmRecharge'),
					content: this.$t('recharge.rechargeBalance'),
					okText: this.$t('introductionTeacher.confirm'),
					okType: "danger",
					cancelText: this.$t('recharge.cancel'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('wallet/moneyRecharge', {
							money: this.amountInfo.amount
						}).then(res => {
							this.$message.success('請前往充值', 1, () => {
								this.handleCancel()
								window.open(res.url, '_blank')
								this.$confirm({
									title: '是否完成充值',
									content: '完成充值',
									okText: this.$t('introductionTeacher.confirm'),
									okType: "danger",
									cancelText: this.$t('recharge.cancel'),
									okButtonProps: {
									    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
									  },
									onOk: () => {
										this.setUserInfo()
										this.$emit('okRecharge')
									},
									onCancel: () => {
										console.log("Cancel");
									},
								});
								
							})
						})
					},
					onCancel: () => {
						console.log("Cancel");
					},
				});

			}
		}
	}
</script>

<style>
</style>